/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VcdsComponentVersionHistory { 
    /**
     * action
     */
    action?: string;
    /**
     * target version
     */
    release_type?: string;
    /**
     * source version
     */
    source_version?: string;
    /**
     * status
     */
    status?: string;
    /**
     * target version
     */
    target_version?: string;
    /**
     * Change timestamp
     */
    timestamp?: Date;
    /**
     * Changed by user
     */
    user?: string;
}

